import { Navigate } from "react-router-dom";
import { useLocation } from "react-router";
import NavigationScroll from "layout/navigationScroll";

const PrivateRoute = ({ children }: any) => {
  const token = sessionStorage.getItem("token");
  const location = useLocation();
  if (!token) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  return <NavigationScroll>{children}</NavigationScroll>;
};
export default PrivateRoute;
